// extracted by mini-css-extract-plugin
export default {"container":"IntroImage-module__container-G5uZOy","toggleImage":"IntroImage-module__toggleImage-BCknZq"};